"use strict"

import React from "react"

export default class ObservationSelectorHolder extends React.Component {
  render() {
    const { className, style, children } = this.props

    return (
      <div
        className={className}
        style={{
          ...style,
          position: "absolute",
          width: "300px",
          height: "350px",
          background: "var(--lanzalake-white)",
          border: "1px solid var(--lanzalake-grey)",
          borderRadius: "3px",
          display: "flex",
          zIndex: 1200, // Set to higher z-index than modals
          flexDirection: "column",
        }}
      >
        {children}
      </div>
    )
  }
}
